import { render, staticRenderFns } from "./cms-item-post.vue?vue&type=template&id=3f1f1241&scoped=true&"
import script from "./cms-item-post.vue?vue&type=script&lang=js&"
export * from "./cms-item-post.vue?vue&type=script&lang=js&"
import style0 from "./cms-item-post.vue?vue&type=style&index=0&id=3f1f1241&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1f1241",
  null
  
)

export default component.exports